import "./TextArea.scss"
import React from "react"

const TextArea = ({ className, onChange, ...rest }) => {
  return (
    <textarea
      className={["TextArea", className].join(" ")}
      onChange={e => onChange(e.target.value, e)}
      {...rest}
    />
  )
}

TextArea.displayName = "TextArea"

export default TextArea



// WEBPACK FOOTER //
// ./src/lib/TextArea.js